import * as React from "react";
import { DynamicForm } from "../../util/DynamicForm";
import { useGeneratedForm } from "../../hooks/useGeneratedForm";
import MutationHandler from "../../util/MutationHandler";
import { apiGet } from "../../util/axiosUtil";
import API_URL from "../../config/apiConfig";
import { z } from "zod";

export default function SubscriberRechargeByOwner({
  onCancel,
  data,
  onSuccess,
}) {
  const [planOptions, setPlanOptions] = React.useState([]);
  const FETCH_PLANS_URL = `${API_URL}/api/plans/paid`;

  // 🔹 Fetch plans
  React.useEffect(() => {
    const fetchPlans = async () => {
      try {
        const response = await apiGet(FETCH_PLANS_URL);
        const options =
          response?.data?.data?.map((plan) => ({
            id: plan.id,
            name: plan.name,
          })) || [];
        setPlanOptions(options);
      } catch (error) {
        console.error("Error fetching plans:", error);
      }
    };

    fetchPlans();
  }, []);

  const formConfig = {
    plan: {
      label: "Subscription Plan",
      type: "select",
      options: planOptions,
      defaultValue: "",
      required: true,
      validation: z.preprocess(
        (val) => (val === "" ? 0 : Number(val)),
        z.number().superRefine((value, ctx) => {
          if (value < 1) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: "Subscription is required",
            });
          }
        }),
      ),
    },
  };

  return (
    <MutationHandler
      mutationFn={(formData) =>
        apiGet(
          // ✅ NEW OWNER ENDPOINT
          `${API_URL}/api/subscribers/recharge/plan/${data.id}/${formData.plan}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        )
      }
      onCancel={onCancel}
      onSuccess={onSuccess}
    >
      {(mutation) => (
        <RechargeForm
          formConfig={formConfig}
          onSubmit={(value) => mutation.mutate(value)}
          isLoading={mutation.isPending}
          onCancel={onCancel}
        />
      )}
    </MutationHandler>
  );
}

function RechargeForm({ formConfig, onSubmit, isLoading, onCancel }) {
  const form = useGeneratedForm(formConfig, async ({ value }) => {
    onSubmit(value);
  });

  return (
    <DynamicForm
      form={form}
      formConfig={formConfig}
      isLoading={isLoading}
      onCancel={onCancel}
      buttonText={"Recharge"}
    />
  );
}
